module.exports = __webpack_public_path__ + "feda3b81e194fc15b235bb826d7d6c62.svg";